<mat-toolbar
	color="primary"
	id="mainAppToolbar"
>
	<mat-toolbar-row
		[@slideInOut]
		[class.hiddenBurgerMenu]="!showBurgerMenu()"
	>
		@if (showBurgerMenu()) {
			<div
				(click)="sidenav().toggle()"
				[matRippleCentered]="true"
				class="matRippleCon"
				mat-ripple
			>
				<div
					[class.xVisible]="sidenav().opened"
					class="hamburgerCloseBtn"
				>
					<div
						[@hamburguerX]="!sidenav().opened ? 'hamburguer' : 'topX'"
						class="icon-bar"
					></div>
					<div
						[@hamburguerX]="!sidenav().opened ? 'hamburguer' : 'hide'"
						class="icon-bar"
					></div>
					<div
						[@hamburguerX]="!sidenav().opened ? 'hamburguer' : 'bottomX'"
						class="icon-bar"
					></div>
				</div>
			</div>
		}

		<div>
			<sim-logo />

			@if (showSystemWarning()) {
				<sim-system-warning
					(timeUp)="timeUp.emit()"
					(cancelShutdown)="cancelShutdown.emit()"
					[nextSystemShutdown]="nextSystemShutdown()"
				/>
			}
		</div>

		<div class="toolbarMenuContainer">
			<sim-toolbar-menu />
		</div>
	</mat-toolbar-row>
</mat-toolbar>
